import { render, staticRenderFns } from "./OfficesSearchView.vue?vue&type=template&id=512b651c&scoped=true&"
import script from "./OfficesSearchView.vue?vue&type=script&lang=js&"
export * from "./OfficesSearchView.vue?vue&type=script&lang=js&"
import style0 from "./OfficesSearchView.vue?vue&type=style&index=0&id=512b651c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b651c",
  null
  
)

export default component.exports